import { ESOCIAL_DISABLED_STATUS } from './contants';

export function getStatusBadgeTheme(status) {
  switch (status) {
  case 'S':
    return 'success';
  case 'P':
  case 'A':
  case 'L':
    return 'warning';
  default:
    return 'danger';
  }
}

export function isEsocialPending(esocialStatus) {
  return esocialStatus === 'P';
}

export function isEsocialDisabledStatus(esocialStatus) {
  const disabledStatus = ESOCIAL_DISABLED_STATUS.map(status => status.name);

  return disabledStatus.includes(esocialStatus);
}
